import $ from 'jquery'
import { isInViewport } from './utils/utils'

async function init () {
  $('.icon-slider').each(async function () {
    const sliderIsVisible = this.offsetParent !== null // slider is not shown in all viewports
    if (sliderIsVisible) {
      await import(/* webpackChunkName: "slick" */ 'slick-carousel/slick/slick')
      await initSlider($(this))
    }
  })
}

async function initSlider (element) {
  var sliderNav = $(element).parents('.icons-box').find('.dot')

  let lazyBool = isInViewport(element),
    slick = $(element).slick(getOptions(lazyBool))

  slick.on('lazyLoaded', function (evt, slick, $img) {
    if ($img.attr('data-srcset') !== undefined) {
      $img.attr('srcset', $img.attr('data-srcset'))
      $img.removeAttr('data-srcset')
    }
    $img.attr('src', $img.attr('data-src'))
    $img.removeAttr('data-src')
  })
  indicator($(element), sliderNav)

  $(window).on('scroll', positionCheck)
  $(window).on('resizeend', positionCheck)

  function positionCheck () {
    if (lazyBool) {
      $(window).off('scroll', positionCheck)
      $(window).off('resizeend', positionCheck)
    } else {
      if (isInViewport(element)) {
        //console.log(element);
        $(element).slick('unslick')
        $(element).slick(getOptions(true))
        $(window).off('scroll', positionCheck)
        $(window).off('resizeend', positionCheck)
      }
    }
  }

  function getOptions (lazy) {
    return {
      lazyLoad: (lazy ? 'ondemand' : 'none'),
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: true,
      cssEase: 'linear',
      variableWidth: false,
      variableHeight: true,
      arrows: false,
      responsive: [{
        breakpoint: 992,
        settings: {
          centerPadding: '30vw',
        }
      }, {
        breakpoint: 768,
        settings: {
          centerPadding: '22vw',
        }
      }, {
        breakpoint: 576,
        settings: {
          centerPadding: '0',
        }
      }],
    }
  }
}

function indicator (slider, sliderNav) {
  sliderNav.each(function () {
    $(this).on('click', function () {
      let id = $(this).data('slider-indicator')
      slider.slick('slickGoTo', id, !true)
    })
  })

  slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    sliderNav.each(function () {
      $(this).removeClass('active')
      if ($(this).data('slider-indicator') === nextSlide) {
        $(this).addClass('active')
      }
    })
  })
}

export default {
  init
}
